<template>
  <div id="app" class="app-container">
    <router-view />
  </div>
</template>
<script>
export default {
};
</script>
<style lang="less">
html, body {
  height: 100%;
}
.app-container {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
}
</style>
